import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './Auth.css';

const API_URL = 'https://serv.mesds.ru/api';

function Auth({ onAuthSuccess }) {
    const [step, setStep] = useState('email'); // 'email', 'code', 'register'
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [username, setUsername] = useState('');
    const [phone, setPhone] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [timer, setTimer] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Таймер для повторной отправки кода
    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [timer]);

   
    const startTimer = (seconds = 300) => {
        setTimer(seconds);
    };
    // функция проверки email
    const validateEmail = (email) => {
        const re = /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/;
        return re.test(email);
    };

    const handleEmailChange = (e) => {
       
        setEmail(e.target.value);
        if (error) {
            setError('');
        }
    };

    // Запрос кода на email
    const requestCode = async () => {
        if (!email) {
            setError('Введите email');
            return;
        }
         if (!validateEmail(email)) {
            setError('Введите корректный email (пример: user@domain.com)');
            return;
        }
        
        setError('');
        setLoading(true);
        
        try {
           const response = await axios.post(`${API_URL}/auth/request-code`, { email });
            console.log('Response:', response.data);

           if (response.data.status === 'ok') {
            setStep('code');
            startTimer(300);
        }
        } catch (err) {
            setError('Ошибка отправки кода. Попробуйте позже.');
        } finally {
            setLoading(false);
        }
    };

    // Повторная отправка кода
    const resendCode = async () => {
        if (timer > 0) {
            setError(`Подождите ${Math.floor(timer / 60)}:${timer % 60 < 10 ? '0' : ''}${timer % 60} перед повторной отправкой`);
            return;
        }
        
        setLoading(true);
        setError('');
        
        try {
            await axios.post(`${API_URL}/auth/request-code`, { email });
            startTimer(300);
        } catch (err) {
            setError('Ошибка отправки кода');
        } finally {
            setLoading(false);
        }
    };

    // Проверка кода
    const verifyCode = async () => {
       
        if (!code || code.length < 5) {
            setError('Введите код из 5 цифр');
            return;
        }
        
        setLoading(true);
        setError('');
        
        try {
            const response = await axios.post(`${API_URL}/auth/verify-code`, { email, code });         
           
            if (response.data.status === 'ok') {
                const { access_token, refresh_token, user } = response.data;
                 
                localStorage.setItem('access_token', access_token);
                localStorage.setItem('refresh_token', refresh_token);
               
                if (onAuthSuccess) {                   
                    onAuthSuccess(access_token, refresh_token, user);                    
                } else {
                    setError('onAuthSuccess is undefined!');
                }
                return 'success';
            } else if (response.data.status === 'need_registration') {
                setStep('register');
                return 'need_registration';
            }
        } catch (error) {     
            setError('Неверный код или код истёк');
            return 'error';
        } finally {
            setLoading(false);
        }
    };

    // Регистрация нового пользователя
    const register = async () => {
        if (!phone) {
            setError('Телефон обязателен для заполнения');
            return;
        }
        // Валидация телефона (минимум 10 цифр)
        const digits = phone.replace(/\D/g, '');
        if (digits.length < 10) {
            setError('Введите корректный номер телефона');
            return;
        }
        setLoading(true);
        setError('');
        
        try {
            const response = await axios.post(`${API_URL}/auth/register`, {
                email,
                code,
                username: username || '',
                phone,
                first_name: firstName,
                last_name: lastName
            });
            
            const { access_token, refresh_token, user } = response.data;
            localStorage.setItem('access_token', access_token);
            localStorage.setItem('refresh_token', refresh_token);
            if (onAuthSuccess) {
                onAuthSuccess(access_token, refresh_token, user);
            }
        } catch (err) {
            setError(err.response?.data || 'Ошибка регистрации');
        } finally {
            setLoading(false);
        }
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    // Шаг 1: Ввод email
    if (step === 'email') {
        return (
            <div className="auth-container">
                <div className="auth-form">
                    <h2>Вход в MesDs</h2>
                    <div className="auth-description">
                        Введите ваш email, и мы отправим код подтверждения
                    </div>
                    <input
                        type="email"
                        // placeholder="Email"
                        value={email}
                        onChange={handleEmailChange}
                        onKeyPress={(e) => e.key === 'Enter' && requestCode()}
                        className={error ? 'input-error' : ''}
                        autoFocus
                    />
                   
                    {error && <div className="auth-error">{error}</div>}
                    <button onClick={requestCode} disabled={loading}>
                        {loading ? 'Отправка...' : 'Продолжить'}
                    </button>
                    <div className="auth-footer"><p>© {new Date().getFullYear()} DedonSoft</p> </div>
                </div>
                
            </div>
        );
    }

    // Шаг 2: Ввод кода
    if (step === 'code') {
        return (
            <div className="auth-container">
                <div className="auth-form">
                    <h2>Подтверждение</h2>
                    <div className="auth-description">
                        Код отправлен на {email}
                    </div>
                    <input
                        type="text"
                        placeholder="_  _  _  _  _"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && verifyCode()}
                        maxLength={5}
                        autoFocus
                    />
                    {error && <div className="auth-error">{error}</div>}
                    <button onClick={() => {                       
                        verifyCode();
                    }} disabled={loading}>
                        {loading ? 'Проверка...' : 'Войти'}
                    </button>
                    <div className="auth-links">
                        {timer > 0 ? (
                            <div className="auth-timer">
                                Повторно отправить код через {formatTime(timer)}
                            </div>
                        ) : (
                            <button className="btn-link" onClick={resendCode} disabled={loading}>
                                Отправить код повторно
                            </button>
                        )}
                        <button className="btn-link" onClick={() => setStep('email')}>
                            Изменить email
                        </button>
                        <div className="auth-footer"><p>© {new Date().getFullYear()} DedonSoft</p> </div>
                    </div>
                </div>
            </div>
        );
    }

    // Шаг 3: Регистрация
    if (step === 'register') {
        return (
            <div className="auth-container">
                <div className="auth-form auth-form-wide">
                    <h2>Завершение регистрации</h2>
                    <div className='auth-email'>
                        <span >Ваш Email: {email}</span>
                    </div>
                    <div className="auth-description">
                        Заполните информацию о себе
                    </div>
                    
                    <div className="auth-field-phone">
                        <label>Телефон *</label>
                        <PhoneInput
                            international
                            defaultCountry="RU"
                            value={phone}
                            onChange={setPhone}
                            limitMaxLength={true}
                            className="auth-phone-input"                        
                        />
                    </div>
                    
                    <div className="auth-field">
                        <label>Имя пользователя</label>
                        <input
                            type="text"
                            placeholder="Как вас будут называть"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    
                    <div className="auth-row">
                        <div className="auth-field">
                            <label>Имя</label>
                            <input
                                type="text"
                                placeholder="Имя"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                            />
                        </div>
                        <div className="auth-field">
                            <label>Фамилия</label>
                            <input
                                type="text"
                                placeholder="Фамилия"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                            />
                        </div>
                    </div>
                    
                    {error && <div className="auth-error">{error}</div>}
                    
                    <button onClick={register} disabled={loading}>
                        {loading ? 'Регистрация...' : 'Регистрация'}
                    </button>
                    <div className="auth-footer"><p>© {new Date().getFullYear()} DedonSoft</p> </div>  
                </div>                
            </div>
        );
    }
    
}

export default Auth;